import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { isEmpty } from "lodash";
import Limiter from "../../../../../components/atoms/Limiter";
import ExpandLink from "../../../../../components/atoms/Limiter/ExpandLink";
import TableSorter from "../../../../../components/atoms/TableSorter";
import JaxCkbClinicalTrialsTable from "./JaxCkbClinicalTrialsTable";

const renderTable = (props) => {
  return <JaxCkbClinicalTrialsTable {...props} />;
};

const renderLimiter = (props) => {
  return (
    <div className="varsome-inner-container">
      <Limiter
        {...props}
        ExpandLink={(p) => (
          <div className="tw-p-2">
            <ExpandLink {...p} />
          </div>
        )}
        items={props.sortedItems}
        limit={5}
        renderContent={renderTable}
      />
    </div>
  );
};

const sortByStatus = (a, b) => {
  const x = a.recruitment;
  const y = b.recruitment;
  if (x === "" || x === null) return 1;
  if (y === "" || y === null) return -1;
  if (x === y) return 0;
  return x < y ? -1 : 1;
};

function JaxCkbClinicalTrialsContent(props) {
  const { clinicalTrials } = props;
  const [formattedItemsList, setFormattedItemsList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const search$ = useRef(new Subject());

  const handleChange = (event) => {
    search$.current.next(event.target.value);
  };

  useEffect(() => {
    const items = clinicalTrials;
    setFormattedItemsList(items);
  }, []);

  useEffect(() => {
    const subscription = search$.current
      .pipe(debounceTime(500))
      .subscribe((x) => setSearchTerm(x));
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (formattedItemsList) {
      const escaped = searchTerm.replace(/[-[/\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      const reg = new RegExp(escaped, "gi");
      const results = formattedItemsList.filter(
        (field) =>
          field.title.match(reg) ||
          field.phase.match(reg) ||
          field.recruitment.match(reg) ||
          field.nctid.match(reg)
      );
      setSearchResults(results);
    }
  }, [searchTerm, formattedItemsList]);

  if (!isEmpty(formattedItemsList)) {
    return (
      <React.Fragment>
        <div className="tw-p-5 tw-inline-block">
          <div className="tw-text-coolGray-400 tw-text-xs tw-flex tw-items-center">
            <div className="tw-mr-1">
              SEARCH FOR TITLE, PHASE, RECRUITMENT, NCTID:
            </div>
          </div>
          <div className="tw-py-2" style={{ width: "400px" }}>
            <input
              type="text"
              className="form-control tw-mb-2"
              placeholder="title, phase, recruitment, nctid"
              onChange={handleChange}
            />
          </div>
        </div>
        <TableSorter
          {...props}
          items={searchResults}
          defaultSortedField="recruitment"
          defaultComparator={sortByStatus}
          renderContent={renderLimiter}
        />
      </React.Fragment>
    );
  }
  return null;
}

JaxCkbClinicalTrialsContent.propTypes = {
  clinicalTrials: PropTypes.arrayOf(
    PropTypes.shape({
      nctid: PropTypes.string,
      phase: PropTypes.string,
      recruitment: PropTypes.string,
      title: PropTypes.string,
    })
  ),
};

JaxCkbClinicalTrialsContent.defaultProps = {
  clinicalTrials: [],
};

export default JaxCkbClinicalTrialsContent;
